const CloseAccount = {
  state: () => ({
    code: '',
    agree: false,
  }),
}
export default CloseAccount
